import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import config from '../../config';
import { useGlobalContext } from '../../GlobalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GetAll, Delete } from '../../service/BlogService';

export default function BlogList() {

  const {
    setIsLoading,
    setAppError,
    setAppErrorMessage,
    setAppErrorTitle,
    setAppErrorMode,
  } = useGlobalContext();

  const [blogs, setBlogs] = useState([]);
  const [keyword, setKeyword] = useState('');
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const fetchBlogList = async (currentPage = page) => {
    try {
      setIsLoading(true);
      const response = await GetAll(currentPage, limit, keyword);
      setBlogs(response.blogs || []);
      setTotalPages(response.totalPages || 1); // backend should return totalPages
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = () => {
    setPage(1);
    fetchBlogList(1);
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this blog?");
    if (!confirmDelete) return;

    try {
      setIsLoading(true);
      const response = await Delete(id);
      if (response.status === 200) {
        setAppError(true);
        setAppErrorTitle("Action Response");
        setAppErrorMessage(response.message || "Blog Successfully Deleted");
        setAppErrorMode("success");
        fetchBlogList(page); // reload after deletion
      } else {
        setAppError(true);
        setAppErrorTitle("Error");
        setAppErrorMessage(response.message || "Failed to delete blog. Please try again.");
        setAppErrorMode("error");
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to delete blog. Please try again.");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogList(page);
  }, [page]);

  return (
    <>
      <Helmet>
        <title>Blog List | {config.appName} </title>
      </Helmet>
      <div className='container'>
        <div className='page'>
          <div className='page-heading'>
            <h1>Blog List</h1>
            <span>
              <Link to="/"> Dashboard </Link> / Blog List
            </span>
          </div>
          <div className='page-content'>
            <div className="portal">
              <div className='portal-body'>
                
                <div className='table-content'>
                  <table className='table table-bordered table-condensed'>
                    <thead>
                      <tr>
                        <th>Sl.no</th>
                        <th>Image</th>
                        <th>Blog Category</th>
                        <th>Name</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {blogs && blogs.length > 0 ? (
                        blogs.map((blog, index) => (
                          <tr key={blog.id}>
                            <td>{(page - 1) * limit + index + 1}</td>
                            <td>
                              <img
                                src={`${config.imageBasePath}/blog/${blog.id}.${blog.image}`}
                                alt={blog.name}
                                className='img-fluid image-xs'
                              />
                            </td>
                            <td>{blog.blogCategory.name}</td>
                            <td>{blog.name}</td>
                            <td>{blog.status}</td>
                            <td>
                              <Link to={`/blog/edit/${blog.id}`} className='btn btn-sm btn-primary' title="Edit Blog">
                                <FontAwesomeIcon icon="fa-solid fa-pen-to-square" />
                              </Link>&nbsp;&nbsp;
                             
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center">No blogs found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                 {/* Pagination Controls */}
                <div className="pagination-buttons">
                  {page > 1 && (
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => setPage(prev => Math.max(prev - 1, 1))}
                    >
                      Prev
                    </button>
                  )}

                  <span className="align-self-center px-3">Page {page} of {totalPages}</span>

                  {page < totalPages && (
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => setPage(prev => Math.min(prev + 1, totalPages))}
                    >
                      Next
                    </button>
                  )}
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
